import { atom } from "jotai";
import { Credit } from "@/core/entities/credit";

export enum CreditTabType {
  INFORMATION = "Information",
}

interface CreditState {
  credit: Credit | null;
  isLoading: boolean;
  error: Error | null;
}

const initialState: CreditState = {
  credit: null,
  isLoading: false,
  error: null,
};

export const creditAtomState = atom<CreditState>(initialState);

export const creditAtom = atom(get => get(creditAtomState).credit);
export const isLoadingAtom = atom(get => get(creditAtomState).isLoading);
export const errorAtom = atom(get => get(creditAtomState).error);
export const creditRemittanceItemIdAtom = atom(get => get(creditAtomState).credit?.remittanceItemId);
export const creditSelectedTabAtom = atom<CreditTabType | null>(null);